<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container simple-container charity-invitation-sent-container">
		<div><i class="fa fas fa-check-circle"></i></div>
		<h1>Invitation Sent </h1>
		<p>Your invitation has been sent via email.</p>
		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, <br> sed do eiusmod tempor incididunt ut labore et
			dolore magna aliqua.</p>
		<input type="button" class="btn btn-primary primary-default-btn" value="Send another invite" (click)="goTo()">
	</section>
</section>
